// Re-exports from unified color system
import { useMemo } from 'react';
import { PRIMITIVE_COLORS, SEMANTIC_COLORS } from '../residentColors';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

export const ACCOUNT_COLORS = {
  background: SEMANTIC_COLORS.background.primary,
  contentBackground: SEMANTIC_COLORS.background.secondary,
  navActiveBackground: PRIMITIVE_COLORS.resioBlue,
  outerBorder: PRIMITIVE_COLORS.resioBlueBorder,
  innerBorder: PRIMITIVE_COLORS.gray700,
  divider: PRIMITIVE_COLORS.gray700,
  textPrimary: SEMANTIC_COLORS.text.primary,
  textSecondary: PRIMITIVE_COLORS.gray400,
  textMuted: PRIMITIVE_COLORS.gray500,
  avatarBackground: PRIMITIVE_COLORS.white10,
  buttonOutline: SEMANTIC_COLORS.text.primary,
  buttonPrimary: PRIMITIVE_COLORS.resioBlue,
  chevronColor: SEMANTIC_COLORS.text.primary,
} as const;

export function useAccountColors() {
  const { semantic, components, colors } = useThemeColors();
  return useMemo(() => ({
    background: semantic.background.primary,
    contentBackground: semantic.background.secondary,
    navActiveBackground: semantic.interactive.primary,
    outerBorder: semantic.border.primary,
    innerBorder: semantic.border.secondary,
    divider: semantic.border.secondary,
    textPrimary: semantic.text.primary,
    textSecondary: semantic.text.tertiary,
    textMuted: semantic.text.muted,
    avatarBackground: colors.activityIcon.bg,
    buttonOutline: semantic.text.primary,
    buttonPrimary: semantic.interactive.primary,
    chevronColor: semantic.text.primary,
  }), [semantic, components, colors]);
}
